import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnimatedScrollComponent } from './animated-scroll.component';

const routes: Routes = [{ path: '', component: AnimatedScrollComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AnimatedScrollRoutingModule { }
